import { IFieldAccess, IPrivilege } from '../interfaces/models';
import { ID } from '@datorama/akita';
import { Entity, Column } from '../entity/index';
import { LanguagePage, PageTitles, ColumnType } from '../lib/common';

@Entity({
  name: PageTitles.privilege,
  language: LanguagePage.privilege,
})
export class Privilege implements IPrivilege {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 2,
    },
  })
  action: string;
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 4,
    },
  })
  condition: string;
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 3,
    },
  })
  functionName: string;
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
  })
  service: string;

  id: ID;
  createdAt: Date;
  modifiedAt: Date;
  createdBy: string;
  modifiedBy: string;
  href: string;
  fieldAccess: IFieldAccess;
  active: boolean;

  constructor(
    privilege: IPrivilege = {
      id: '',
      createdAt: new Date(),
      modifiedAt: new Date(),
      createdBy: '',
      modifiedBy: '',
      href: '',
      action: '',
      condition: '',
      functionName: '',
      service: '',
      fieldAccess: null,
      active: false,
    }
  ) {
    const {
      id,
      createdAt,
      modifiedAt,
      createdBy,
      modifiedBy,
      href,
      action,
      condition,
      functionName,
      service,
      fieldAccess,
      active,
    } = privilege;

    this.id = id;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.createdBy = createdBy;
    this.modifiedBy = modifiedBy;
    this.href = href;
    this.action = action;
    this.condition = condition;
    this.functionName = functionName;
    this.service = service;
    this.fieldAccess = fieldAccess;
    this.active = active;
  }
}
